import { render } from "./EditProducts.vue?vue&type=template&id=30851ea2"
import script from "./EditProducts.vue?vue&type=script&lang=js"
export * from "./EditProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__